module.exports = __webpack_public_path__ + "51baa2692a7bbcd3023dbe7f58a8586a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-2.png
// module id = 2703
// module chunks = 0